import { SaveOutlined, CloudDownloadOutlined, LoadingOutlined, DeleteOutlined } from '@ant-design/icons'
import { Col, Row, List, Button, Spin, Modal } from "antd";
import React from "react";
import { ConfigOpenBankingModel } from "../../models/UtenteModels";
import { Input } from 'antd'
import { TTFormItem } from '../shared/TTFormItem'
import { TTSelect } from '../shared/TTSelect'
import { RouteComponentProps, withRouter } from 'react-router'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import { renderSelectKeyValue, renderSelectList, renderSelectModel } from '../shared/SelectOptionRenderUtils'
import { KeyValueModel } from '../../models/ModelBase'
import { IAppContext } from '../AppContext'
import { IConfigurazioneService } from '../../services/ConfigurazioneService'

interface TabConfigCCProps {
    clienteId: string
}

class PageConfigCCState extends ConfigOpenBankingModel {
    isLoading: boolean
}

export class TabConfigCC extends React.Component<TabConfigCCProps, PageConfigCCState> {
    service: IConfigurazioneService
    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)
        this.state = new PageConfigCCState()
    }

    async componentDidMount() {
        this.loadConfig();
    }

    async loadConfig() {
        let resp = await this.service.GetConfigOpenBanking(this.props.clienteId)
        this.setState(resp)
        this.setNrPeriodoList(resp.Periodo, resp.NrPeriodo)
        this.setState({ ...this.state, isLoading: false })
    }

    onSaveClick = async () => {
        this.setState({ ...this.state, isLoading: true })
        var resp = await this.service.SaveConfigOpenBanking(this.state)
        if (resp.IsValid === true) {
            this.setState(resp)
            this.setNrPeriodoList(resp.Periodo, resp.NrPeriodo)

        }
        this.setState({ ...this.state, isLoading: false })
    }

    onDeleteClick = async () => {
        Modal.confirm({
            title: "Elimina configurazione",
            content: "Eliminare la configurazione?",
            onOk: async () => {
                let resp = await this.service.DeleteConfigOpenBanking(this.props.clienteId)
                if (resp.IsValid == true)
                    this.loadConfig();
            }
        })
    }

    onPeriodoChange = (e: string) => {
        this.setNrPeriodoList(e)
    }

    onImportClick = async () => {
        this.setState({ ...this.state, isLoading: true })
        var rs = await this.service.ImportConfigOpenBanking(this.state)
        this.setState({ ...this.state, isLoading: false })
    }

    private setNrPeriodoList(periodo: string, nrperiodo?: string) {
        let model = this.state
        let nrPeriodi = this.service.SetNrPeriodoList(periodo);

        if (nrperiodo == null || nrperiodo == "") nrperiodo = nrPeriodi[0]

        this.setState({ ...model, Periodo: periodo, NrPeriodoList: nrPeriodi, NrPeriodo: nrperiodo })
    }


    render() {
        return (
            <>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />} spinning={this.state.isLoading}>
                    <Row>
                        <Col span={8}>
                            <Button disabled={this.state.Connettore == "" || this.state.Connettore == null} type="default" key="save" icon={<CloudDownloadOutlined />} onClick={() => this.onImportClick()}>Importa</Button>
                        </Col>
                        <Col span={2} offset={12}>
                            <Button disabled={this.state.Connettore == "" || this.state.Connettore == null} type="default" style={{ float: 'right' }} key="delete" icon={<DeleteOutlined />} onClick={() => this.onDeleteClick()}>Delete</Button>
                        </Col>
                        <Col span={2}>
                            <Button type="primary" style={{ float: 'right' }} key="save" icon={<SaveOutlined />} onClick={() => this.onSaveClick()}>Salva</Button>
                        </Col>
                    </Row>
                    <TTFormItem label="Connettore" required={true}>
                        <TTSelect size="small" value={this.state.Connettore} onChange={e => this.setState({ Connettore: e as string })}>
                            {renderSelectKeyValue(this.state.ConnettoreList)}
                        </TTSelect>
                    </TTFormItem>
                    <hr />
                    <br />
                    <Row>
                        <Col span={12}>
                            <TTFormItem label="Periodo" required={true}>
                                <TTSelect size="small" value={this.state.Periodo} onChange={e => this.onPeriodoChange(e as string)}>
                                    {renderSelectKeyValue(this.state.PeriodoList)}
                                </TTSelect>
                            </TTFormItem>
                        </Col>
                        <Col span={12}>
                            <TTFormItem label="Nr Periodi" required={true}>
                                <TTSelect size="small" value={this.state.NrPeriodo} onChange={e => this.setState({ NrPeriodo: e as string })}>
                                    {renderSelectList(this.state.NrPeriodoList)}
                                </TTSelect>
                            </TTFormItem>
                        </Col>
                    </Row>
                </Spin>
            </>
        )
    }
}

